import { styled } from "@mui/material";
import Component, { IOwnProps } from "./component";
import { IWithThemeProps } from "../../theme/default.theme";

export default styled(Component)(
  ({ theme, columns }: IWithThemeProps & IOwnProps) => ({
    ".header-card": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme?.spacing(0, 3),
      ".MuiTypography-root": {
        fontWeight: 600,
        padding: theme?.spacing(2, 0),
        fontSize: 18,
      },
    },
    ".custom-header-container": {
      display: "flex",
      alignItems: "center",
    },
    ".cell-content": {
      color: theme?.palette.text.primary,
      fontSize: 16,
    },
    ".order-first": {
      order: -1,
    },
    ".rows-per-page-container": {
      display: "flex",
      alignItems: "center",
      "& .MuiFormControl-root": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
      "& .MuiFormLabel-root": {
        display: "flex",
        marginRight: theme?.spacing(1),
        "&.Mui-focused": {
          color: theme?.palette.text.secondary,
        },
      },
      "& .MuiOutlinedInput-root": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent",
        },
      },
    },
    ".header-cell": {
      textTransform: "uppercase",
      display: "flex",
      alignItems: "flex-start",
      color: theme?.palette.text.disabled,
      ".MuiTypography-root": {
        fontWeight: 600,
      },
    },

    ".sortable": {
      cursor: "pointer",
    },
    ".sortIcon": {
      color: theme?.palette.text.secondary,
    },
    ".MuiSelect-icon": {
      color: theme?.palette.text.secondary,
    },
    ".MuiInputBase-root": {
      color: theme?.palette.text.secondary,
    },
    ".MuiTableCell-root:first-of-type": {
      overflowX: "hidden",
    },
    ...columns.reduce(
      (acc, column) => ({
        ...acc,
        [`.columnWidth-${column.id}`]: {
          width: column.width,
          minWidth: column.width,
          maxWidth: column.width,
          wordWrap: "break-word",
          overflowWrap: "break-word",
          overflowX: "auto",
        },
      }),
      {},
    ),
    ".table-footer": {
      display: "flex",
      justifyContent: "space-between",
      padding: theme?.spacing(2),
      color: theme?.palette.text.secondary,
    },
    ".prev-icon": {
      transform: "rotate(90deg)",
    },
    ".next-icon": {
      transform: "rotate(-90deg)",
    },
  }),
);
